/**
 * The audio ID of the audio element for which the {@link playAudio} action is
 * triggered when new chat message is received.
 *
 * @type {string}
 */
export const INCOMING_USER_REQ_SOUND_ID = 'INCOMING_USER_REQ_SOUND_ID';
